import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import TablePagination from "@mui/material/TablePagination";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { TableSortLabel } from "@mui/material";
import { getComparator, stableSort } from "../../../common-utilities/sortingUtils";

const LabReports = ({ reports }) => {
  //const reportServer = "elabsql1";
  const reportServer = "ENVLAB-File01";
  const reportAccount = "SSRSUser";
  const reportPassword = "P@ssword1!";

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredReports, setFilteredReports] = useState(reports);
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("asc");

  useEffect(() => {
    const filteredResults = reports.filter((report) =>
      Object.values(report).some(
        (value) =>
          typeof value === "string" &&
          value.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );

    setFilteredReports(filteredResults);
  }, [searchTerm, reports]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleReportClick = (reportId) => {
    const reportUrl = `http://${reportAccount}:${reportPassword}@${reportServer}/ReportServer/Pages/ReportViewer.aspx?%2fVLPRSReports%2f${reportId}&rs:Command=Render`;
    window.open(reportUrl, "_blank");
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    const sortedReports = stableSort(filteredReports, getComparator(order, orderBy));
    setFilteredReports(sortedReports);
  };

  return (
    <div>
      <TextField
        label="Search"
        variant="outlined"
        size="small"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: "16px", width: "100%" }}
      />

      <TableContainer
  component={Paper}
  sx={{ maxHeight: 410, overflowY: "auto", width: "99%" }}
>
  <Table sx={{ minWidth: 700 }} aria-label="lab reports table" stickyHeader>
    <TableHead
      sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
    >
      <TableRow>              
        <TableCell>
          <TableSortLabel
            active={orderBy === "description"}
            direction={orderBy === "description" ? order : "asc"}
            onClick={() => handleRequestSort("description")}
          >
            Description/Title
          </TableSortLabel>
        </TableCell>

        <TableCell>
          <TableSortLabel
            active={orderBy === "msrsReport"}
            direction={orderBy === "msrsReport" ? order : "asc"}
            onClick={() => handleRequestSort("msrsReport")}
          >
            Report file name
          </TableSortLabel>
        </TableCell>

        <TableCell>
          <TableSortLabel
            active={orderBy === "reportType"}
            direction={orderBy === "reportType" ? order : "asc"}
            onClick={() => handleRequestSort("reportType")}
          >
            Report Type
          </TableSortLabel>
        </TableCell>
        <TableCell>Update Orderstatus</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {filteredReports
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((report, index) => (
          <TableRow
            key={report.msrsReport}
            sx={{
              backgroundColor:
                index % 2 === 0 ? "rgba(0, 0, 0, 0.04)" : "white",
            }}
          >                 
            <TableCell>{report.description}</TableCell>
            <TableCell component="th" scope="row">
              <a
                href="#"
                onClick={() => handleReportClick(report.msrsReport)}
              >
                {report.msrsReport}
              </a>
            </TableCell>
            <TableCell>{report.reportType}</TableCell>
            <TableCell>
              {report.updateorderstatus ? "Yes" : "No"}
            </TableCell>
          </TableRow>
        ))}
    </TableBody>
  </Table>
</TableContainer>
<TablePagination
  rowsPerPageOptions={[10, 20, 50, 100, 200]}
  component="div"
  count={filteredReports.length}
  rowsPerPage={rowsPerPage}
  page={page}
  onPageChange={handleChangePage}
  onRowsPerPageChange={handleChangeRowsPerPage}
/>
    </div >
  );
};

export default LabReports;
